export const DEFAULT_SERVICES_URLS: string[] = [];
export const DEFAULT_INTERNET_CHECK_INTERVAL = 30000;
export const DEFAULT_INTERNET_CHECK_URLS = ['/icon-livechat.svg'];
export const DEFAULT_CHECK_URL_TIMEOUT = 10000;
export const DEFAULT_OFFLINE_THROTTLE_INTERVAL = 2500;
export const INITIAL_RETRY_INTERVAL = 5000;
export const MAX_RETRY_INTERVAL = 30000;
